/**
 * Non-breaking space
 */
export const NBSP = String.fromCharCode(160);

export const DEG = String.fromCharCode(176);

export const EMPTY_OBJECT = {};

export const MDF_INFINITY = 1000000000000.0;

export const WEBLAYOUT_TOOLBAR = "Toolbar";
export const WEBLAYOUT_TASKMENU = "TaskMenu";
export const WEBLAYOUT_CONTEXTMENU = "MapContextMenu";

export const FUSION_TASKPANE_NAME = "TaskPane";
export const FUSION_MAP_NAME = "Map";
export const FUSION_REDLINE_NAME = "Redline";

export const LAYER_ID_BASE = "LAYER_ID_BASE";
export const LAYER_ID_MG_BASE = "LAYER_ID_MG_BASE";
/**
 * @since 0.14.8
 */
export const LAYER_ID_MG_DYNAMIC_OVERLAY = "LAYER_ID_MG_DYNAMIC_OVERLAY";
export const LAYER_ID_MG_SEL_OVERLAY = "LAYER_ID_MG_SEL_OVERLAY";

export const BLANK_GIF_DATA_URI = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";